import * as nativeApp from 'utils/nativeApp'
import { isIosDevice } from './devices'

type Coordinate = number | string

export function openMap(lat: Coordinate, long: Coordinate) {
  const googleMapsLink = `https://www.google.com/maps/dir/?api=1&destination=${lat},${long}`
  const appleMapsLink = `http://maps.apple.com/?daddr=${lat},${long}`

  if (nativeApp.isAndroid()) {
    nativeApp.openMapOnAndroid({
      latitude: Number(lat),
      longitude: Number(long)
    })

  } else {
    const link = isIosDevice() ? appleMapsLink : googleMapsLink
    window.location.href = link
  }
}